import styled from 'styled-components'

import GooStatusCell from 'components/dashboard/status/GooStatusCell'
import NewArtStatusCell from 'components/dashboard/status/NewArtStatusCell'
import ContinueDraftStatusCell from 'components/dashboard/status/ContinueDraftStatusCell'
import { HideOnSmallerMobile } from 'components/core/layout/Responsive'

export const StatusCellsContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 32px;
  gap: 12px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: column;
    gap: 16px;
  `}
`

function DashboardStatusCells() {
  return (
    <StatusCellsContainer>
      <GooStatusCell />
      <HideOnSmallerMobile>
        <NewArtStatusCell />
        <ContinueDraftStatusCell />
      </HideOnSmallerMobile>
    </StatusCellsContainer>
  )
}

export default DashboardStatusCells
